module.exports = __webpack_public_path__ + "img/jne.0c0fee61.png";